import { useMemo } from 'react';
import { getSSFArgument } from '@/utils/templateEngine';
import * as fmtUtils from '@/utils/spreadsheetFormat';

const useSSFFormats = _ref => {
  let {
    template
  } = _ref;
  // Get 1st SSF argument from the template, if any
  const ssfArgument = useMemo(() => {
    if (!template) return;
    const ssfArg = getSSFArgument(template);
    return ssfArg;
  }, [template]); // Lookup any currently set SSF formatting arguement

  const closestMatchFormat = useMemo(() => {
    if (!ssfArgument) return;
    return fmtUtils.findActiveFormat(ssfArgument) || undefined;
  }, [ssfArgument]); // Summarize SSF template format arguement

  const abbrFormatLabel = useMemo(() => {
    if (!closestMatchFormat) return 'None';
    return closestMatchFormat.ticker || closestMatchFormat.label;
  }, [closestMatchFormat]);
  return {
    ssfArgument,
    closestMatchFormat,
    abbrFormatLabel
  };
};

export default useSSFFormats;